import { atom } from "recoil";
export const umrahPacksVols = atom({
  key: "umrahPacksVols", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
